module.exports = __webpack_public_path__ + "static/media/afl_everyday_digital.31b98de9.webp";